/* eslint-disable max-len */
import { ReactElement } from 'react';
import ExitAdjustmentPanel from './ExitAdjustmentPanel';

const ExitAdjustmentLayout = ({
  schoolYear,
  allowEdit = true,
}: {
  schoolYear?: string;
  allowEdit?: boolean;
}): ReactElement => {
  return (
    <>
      <ExitAdjustmentPanel schoolYear={schoolYear} allowEdit={allowEdit} />
    </>
  );
};

export default ExitAdjustmentLayout;
